import OpenSidebarButton from 'components/OpenSidebarButton'
import React, { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useSelector } from 'react-redux'

const MobilePageHeader = () => {
  // @ts-ignore
  const appReducer = useSelector(state => state.appReducer)
  const [projectName, setProjectName] = useState('')

  useEffect(() => {
    const list = appReducer?.listOfProjects
    const selectedProjectId = appReducer?.appProject

    if (!list || !selectedProjectId) return

    const activeProject = list.find(project => project._id === selectedProjectId)
    setProjectName(activeProject?.projectName)
  }, [appReducer])

  return (
    <div style={{ zIndex: 99999, width: `${isMobile ? '100%' : appReducer.show ? 'calc(100% - 361px)' : 'calc(100% - 80px)'}` }} className='fixed bg-white flex justify-center items-center font-bold text-2xl px-6 py-6 border-b-2 border-softBlack h-16 transition-all ease-in-out duration-300'>
      <OpenSidebarButton />
      <div className='whitespace-nowrap ml-4'>
        {projectName}
      </div>
    </div>
  )
}

export default MobilePageHeader
